import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon';
const InputFieldError = ({ errorMessage }) => {
    return (_jsxs("div", { className: "inline-flex w-fit flex-row items-center justify-start gap-0.5 rounded-md bg-surface-error p-0.75", children: [_jsx(Icon, { variant: "error", className: "h-1 w-1 text-text-error" }), _jsx("span", { className: "text-text-error", children: errorMessage })] }));
};
export default InputFieldError;
